import type { ReactNode } from 'react';

export const symbol_swipe_left_alt: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M600-280q-82 0-133.5-50.5T401-450H194l68 68q9 9 9 21t-9 21q-9 9-21 9t-21-9L101-459q-5-5-7-10t-2-11q0-6 2-11t7-10l119-119q9-9 21-9t21 9q9 9 9 21t-9 21l-68 68h207q14-69 65.5-119.5T600-680q83 0 141.5 58.5T800-480q0 83-58.5 141.5T600-280Zm99-101q41-41 41-99t-41-99q-41-41-99-41t-99 41q-41 41-41 99t41 99q41 41 99 41t99-41Zm-99-99Z"
		/>
	</svg>
);
